import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
`;
export const Header = styled.h2`
  color: #595959;
  font-size: 1.875rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 1.13em;
  @media (max-width: ${({ theme }) => theme.mobile.lg}) {
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    text-align: center;
  }
`;
export const ExpandIcon = styled.div`
  width: 1.125rem;
  height: 1.125rem;
  position: absolute;
  top: 0.75rem;
  right: 0.94em;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
`;
export const Description = styled.div`
  width: 21.375rem;
  flex-shrink: 0;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 0px 0px 12px 0px rgba(188, 188, 188, 0.25);
  padding: 1.69em 1.25em;
  margin-bottom: 1.5em;
  position: relative;
  display: flex;

  p {
    color: #595959;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
    margin: 0 auto;
    margin-bottom: 1.5em;
  }
`;
export const Social = styled.div`
  width: 21.375rem;
  flex-shrink: 0;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 0px 0px 12px 0px rgba(188, 188, 188, 0.25);
  padding: 1.25em 2.13em;
  margin-bottom: 1.5em;
  display: grid;
  justify-content: space-between;
  align-items: center;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 1fr;

  gap: 1.5em;
  img {
    width: 2rem;
    height: 2rem;
    flex-shrink: 0;
    cursor: pointer;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
    padding: 1.25em;
    margin: 0 auto;
    margin-bottom: 1.5em;
  }
`;
export const Finance = styled.div`
  width: 21.375rem;
  flex-shrink: 0;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 0px 0px 12px 0px rgba(188, 188, 188, 0.25);
  padding: 1.35em;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
    padding: 1.25em;
    margin: 0 auto;
    margin-bottom: 1.5em;
  }

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
  }
`;
export const Col1 = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 0.44em;
  a {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  div {
    width: 9.0625rem;
    height: 2.25rem;
    @media (max-width: ${({ theme }) => theme.mobile.md}) {
      width: 49%;
    }
  }
`;
export const Pay = styled.div`
  margin-bottom: 0.44em;
  border-radius: 0.25rem;
  background: #351182;
  flex-shrink: 0;
  color: #fff;
  cursor: pointer;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  justify-content: left;
  padding: 0.5em 1.5em;
  img {
    width: 1.125rem;
    height: 1.125rem;
    flex-shrink: 0;
    margin-right: 0.5em;
  }
`;
export const Email = styled.div`
  margin-bottom: 0.44em;
  padding: 0.5em 1.5em;
  flex-shrink: 0;
  border-radius: 0.25rem;
  cursor: pointer;
  border: 1px solid #707070;
  background: #351182;
  color: #fff;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  align-items: center;
  img {
    width: 1.125rem;
    height: 1.125rem;
    flex-shrink: 0;
    margin-right: 0.5em;
  }
`;
export const Hello = styled.div`
  padding: 0.5em 1.5em;
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 0.25rem;
  border: 1px solid #707070;
  background: #351182;
  color: #fff;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  align-items: center;
  img {
    width: 1.125rem;
    height: 1.125rem;
    flex-shrink: 0;
    margin-right: 0.5em;
  }
`;
export const Share = styled.div`
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 0.25rem;
  border: 1px solid #707070;
  background: #000;
  color: #fff;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 1.125rem;
    height: 1.125rem;
    flex-shrink: 0;
    margin-right: 0.5em;
  }
`;
export const Subscribe = styled.div`
  width: 18.8125rem;
  height: 2.25rem;
  cursor: pointer;
  flex-shrink: 0;
  border-radius: 0.25rem;
  background: #000;
  position: relative;

  img {
    width: 1.125rem;
    height: 1.125rem;
    flex-shrink: 0;
    margin-right: 5em;
    margin-left: 1.13em;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  p {
    color: #fff;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
export const ModalBackground = styled.div`
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  position: fixed;
  width: 100%;
  cursor: pointer;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`;
export const ModalCard = styled.div`
  width: 24.375rem;
  /* height: 33.25rem; */
  background: #fff;
  cursor: auto;
  border-radius: 0.625rem;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  padding: 2.5rem;
  position: relative;
  P {
    color: #595959;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    /* text-align: justify; */
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 20.375rem;
  }
`;
export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 3em;
  margin-top: 2em;
  div {
    width: 4.5em;
    height: 4.5em;
    border-radius: 50%;
    flex-shrink: 0;
    margin-right: 1.44rem;
    overflow: hidden;
    border: 0.15px solid black;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  h1 {
    color: #595959;
    text-align: center;
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;
